export class CSSPropertyNameConverter 
{
  static convertToJS( name:string )
  {
    let splits = name.split( "-" );

    name = "";

    for ( let i = 0; i < splits.length; i++) 
    {
      if ( i !== 0 ) 
      {
        splits[ i ] = splits[ i ][ 0 ].toUpperCase() + splits[ i ].substring( 1 );
      }

      name += splits[ i ];
    }

    return name;
  }

  static convertToCSS( name:string )
  {
    let cssProperty = "";

    if ( /^(moz|webkit)/.test( name ) ) 
    {
      name = "-" + name;
    }

    for ( let i = 0; i < name.length; i++ ) 
    {
      
      let char = name[i];
      
      if ( CSSPropertyNameConverter._isUpperCaseLetter( char ) )  
      {
        cssProperty += "-" + ( char.toLowerCase() );
      }
      else 
      {
        cssProperty += char;
      }
    }

    return cssProperty;
  }

  private static _isUpperCaseLetter( source:string )
  {
    return source.toLowerCase() !== source;
  } 

  static convertPropertyName( name:string, toFormat?:string ) 
  {
    toFormat = toFormat || "css";
    
    if ( "js" === toFormat ) 
    {
      return CSSPropertyNameConverter.convertToJS( name );
    }
    else 
    {
      return CSSPropertyNameConverter.convertToCSS( name );
    }
  }

}